import { handleLogout } from "../api/authApis";
import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllWorkOrdersBySetId = async (
  organisationID = "",
  setId = ""
) => {
  let assetFilters = {
    $and: [
      {
        organisation: {
          id: {
            $eq: organisationID,
          },
        },
        sets: {
          id: {
            $in: setId,
          },
        },
        status: {
          $in: ["inProgress", "onHold"],
        },
      },
    ],
  };

  const queryParams = {
    sort: ["countNumId:desc"],
    filters: assetFilters,
    populate: [
      "image",
      "file",
      "daysRepeat",
      "createdByUser",
      "updatedByUser",
      "createdByUser.profileImage",
      "people.profileImage",

      "location",
      "area",
      "parts",
      "sets",
      "people.role",
      "people.userProfile",
      "teams",
      "work_request",
      "customer",
      "assets",
      "assets.image",
      "parts.image",
      "procedure.fields",
      "report.user",
      "report.part.part",
      "report.part.amount",
      "report.timeTracking.user",
      "report.reportItems",
      "report.reportItems.file",
      "report.reportItems.options",
      "report.reportItems.action.people.role",
      "report.reportItems.action.teams",
      "report.reportItems.actions",
      "report.reportItems.actions.evidences",
      "report.parts.part.image",
      "report.timeTracking.user",
      "report.otherCosts",
      "reason",
      "reason.user",
      "reason.image",
    ],
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllWorkOrdersByLocationID = async (
  location,
  organisationID = ""
) => {
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters: {
        $and: [
          {
            organisation: {
              id: {
                $eq: organisationID,
              },
            },
          },
          {
            location: {
              id: {
                $eq: location,
              },
            },
          },
        ],
      },
      populate: ["procedure"],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getPreventiveOrdersOfAsset = async (
  aid,
  organisationId = "",
  allIds = []
) => {
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters: {
        assets: {
          organisation: {
            id: {
              $eq: organisationId,
            },
          },
          id: {
            $in: [aid],
          },
        },
        location: {
          id: {
            $in: allIds,
          },
        },
      },
      populate: ["procedure", "location"],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAssigneWorkOrderForPeople = async (
  organisationID = "",
  peopleId = ""
) => {
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters: {
        organisation: {
          id: {
            $eq: organisationID,
          },
        },
        people: {
          id: {
            $eq: peopleId,
          },
        },
      },
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const fetchInvLocationsOptions = async (organisationID = "") => {
  const queryParams = {
    organisation: organisationID,
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-order/inventory-locations?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    return response?.data;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
